import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playsimple",
  "use": "icon-playsimple-usage",
  "viewBox": "0 0 17 20",
  "content": "<symbol viewBox=\"0 0 17 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-playsimple\">\n<path d=\"M0 18.2515V1.7483C0 0.974898 0.840391 0.494312 1.50699 0.886382L15.5347 9.13798C16.192 9.52458 16.192 10.4752 15.5347 10.8619L1.50699 19.1134C0.840391 19.5056 0 19.0249 0 18.2515Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol